import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { InputNumberMask } from '../../../../../CommonComponents/OPL/Input/InputNumberMask';
import { FormFields } from '../../../components/UpsertInsuranceModal/UpsertInsuranceModal.meta';

export const HealthFamilyDeductible = () => {
  const formBag = useFormContext<FormFields>();

  return (
    <Controller
      control={formBag.control}
      name="HealthFamilyDeductible"
      render={({ field: { onChange, ...field } }) => (
        <InputNumberMask
          {...field}
          label="Family Deductible"
          decimalScale={2}
          allowNegative={false}
          leftIcon="far fa-dollar-sign"
          innerText="/year"
          maxLength={14}
          onValueChange={({ floatValue }) => onChange(floatValue ?? null)}
        />
      )}
    />
  );
};
